import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLastFrame = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M11.6667 5H3.75C3.05964 5 2.5 5.55964 2.5 6.25V13.75C2.5 14.4404 3.05964 15 3.75 15H11.6667C12.357 15 12.9167 14.4404 12.9167 13.75V6.25C12.9167 5.55964 12.357 5 11.6667 5Z",
			stroke: "#545F7E",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.6641 3.75V16.25",
			stroke: "#545F7E",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgLastFrame);
export default ForwardRef;
